import { cn } from "@utils/cn";
import { HTMLAttributes } from 'react';

export const TableRow = ({
    className,
    ...props
}: HTMLAttributes<HTMLTableRowElement>) => (
    <tr className={cn('border-b transition-colors', className)} {...props} />
);
